import React from "react";

import CardWithHeaderTemplate from "../../../components/cardWithHeaderTemplate";
import ListHeader from "./listHeader";
import DisputesListBody from "./disputesListBody";

const DisputesList = () => {

    return (
        <CardWithHeaderTemplate
            header={<ListHeader/>} 
            body={<DisputesListBody/>} 
            footer={null}
            extraCardClassName = {`blur shadow-blur max-height-vh-70 h-fix-100`}
            extraBodyClassName = {`overflow-auto overflow-x-hidden`}
        />
    );
};

export default DisputesList;